export type FormItemClearProps = {
  onClear?: () => void;
};

export const FormItemClear = (props: FormItemClearProps) => {
  return (
    <div
      className="v-form-item-clear"
      onClick={props.onClear}
      onMouseDown={(e) => {
        e.preventDefault();
      }}
    />
  );
};
